import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisabledTextModule } from '@shared/core/components/disabledText';
import { FormForMemberCardModule } from '@shared/core/modules/forms/formTypes/forMemberCard';

import { AuthHeaderModule } from '../../components/authHeader';

import { AuthForMemberCardComponent } from './auth-for-member-card.shared.component';

@NgModule({
    declarations: [
        AuthForMemberCardComponent
    ],
    imports: [
        CommonModule,
        AuthHeaderModule,
        FormForMemberCardModule,
        DisabledTextModule,
    ],
    exports: [
        AuthForMemberCardComponent
    ],
    providers: [],
})
export class AuthForMemberCardModule { }
